export const retailId = 'retail_id';
